import React, { useState } from "react";
import "./Story.css";
import { storyContent } from "../../data/content";
import storyImg from "../../assets/images/sec2.png";

const Story = () => {
  const [showContent, setShowContent] = useState(false);

  return (
    <section
      id="story"
      className={`story ${showContent ? "show" : ""}`}
      onMouseEnter={() => setShowContent(true)}
    >
      <div className="story-image-wrapper">
        <img src={storyImg} alt="Fairuz portrait" className="story-image" />
      </div>

      <div className="story-content">
        <h2 className="story-title">{storyContent.title}</h2>

        <div className="story-text">
          {storyContent.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Story;